<div fxLayout="row wrap">

  <div class="container" fxFlex="99%" fxFlex.lt-md="100%" fxLayout="column wrap">
    <!-- <div class="urlDiv" fxLayout="row wrap">
      <a class="urls" href="">
        Home /
      </a>
      <a  class="urls" href="/hitmaker">
         &nbsp;Hitmaker /
      </a>
      <a  class="urls" href="/hitmaker/{{movieId}}">
        &nbsp;{{movieName}} /
</a>
       <a  class="urls"  href="javascript:void(0);">
        &nbsp;post-production
     </a>
      </div> -->
    <h2 class="heading">POST-PRODUCTION</h2>
    <span class="newPara">Film Music is intriguing. A score can either elevate a film's story or degrade the film. A great film score is essential
    to the emotional impact of the film. When a producer picks a score, there are countless choices. The Producers are
    coming to you, seeking your input and ideas on potential music choices and scores for their feature film. Note: these
    are temp scores and have not been recorded with full orchestration.
    Check out the musical artists. You'll watch the opening sequences from the films with each of the competing Composer's
    proposed score. Then rate-rank the auditions. See and hear how a great composer can radically change the impact of a
    movie and help promote the amazing work of these incredibly talented composers.</span>
    <br><br><br>

    <div fxLayout="row" style="justify-content: center; text-align: center;margin-top: -3%">
      <button class="castingBtn" (click)="pickScore()"
      appTrackClick
      [buttonProps]="{
        title:'hitmaker_post_production_pick_the_score',
        feature_context:'HITMAKER'
      }"
      >Pick The Score</button>
      <button class="castingBtn" (click)="uploadDetails()" *ngIf="admin"
      appTrackClick
      [buttonProps]="{
        title:'hitmaker_post_production_upload',
        feature_context:'HITMAKER'
      }"
      >Upload</button>
    </div>
  </div>

  <div fxLayout="row wrap" class="casting-div" fxLayoutGap="15px" style="margin: 31px;">
    <div *ngFor="let details of stageContentDTOs" class="margin-div" [class.show-button-displayed]="details.hidden == true">

      <div class="content" fxLayout="row wrap">

        <mat-card fxLayout="row wrap" style="padding: 0; align-content: space-between;">

          <div *ngIf="playVideo" class="video-overlay">
            <iframe class="iframe-video" [src]="video" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
            <div class="close-icon" (click)="closeVideo()">&#10006;</div>
          </div>

          <div class="image-container" (click)="playVideo1(details.contentUrl)">
            <img class="img" src="{{details.thumbnailURL}}">
            <button href="" class="video-icon">
              <img src="/../../../../../../assets/images/youtube_play_icon.png" alt="Play Video">
            </button>
          </div>

          <mat-card-header style="margin-left: 2%; width: 90%; cursor: pointer;">
            <mat-card-title class="title">{{details.stageContentLabel | titlecase}}</mat-card-title>
          </mat-card-header>

          <mat-card-content *ngIf="admin" style="margin-bottom: 0px; width: 98%; cursor: pointer;">
            <p class="order">Order: {{details.order}}
            </p>
          </mat-card-content>

          <span ng-if="!details.upvoted" style="float:left; padding-bottom:4%; padding-left:4%; font-size: 67%"
            class="ng-scope"><a><button md-button class="md-ink-ripple upvote-off ng-scope"
                (click)="upvoteContent(details)" ng-if="!details.comingSoon" type="button"
                [ngClass]="{'upvote-on': details.upvoted}"
                appTrackClick
                [buttonProps]="{
                  title: 'hitmaker_pre_production_jewel',
                  feature_context:'HITMAKER'
                }"
                ></button>
              {{ details.upvoted ? 'JEWELED' : 'JEWEL' }}</a></span>

          <div *ngIf="admin" class="buttons" fxFlex="row wrap" fxLayoutGap="1.7px" fxFlex="100%"
            style="align-self: center; text-align: center;">
            <div id="btnDiv" fxFlex="row">
              <button style="color: #36a344;" (click)="updateShowContent(details)"
              appTrackClick
              [buttonProps]="{
                title:'hitmaker_post_production_update',
                feature_context:'HITMAKER'
              }"
              >UPDATE</button>
            </div>
            <button class="btnDiv show" *ngIf="details.hidden==true"
              (click)="showStageContent(details.id)"
              appTrackClick
              [buttonProps]="{
                title:'hitmaker_post_production_show',
                feature_context:'HITMAKER'
              }"
              >SHOW</button>
            <button class="btnDiv hide" *ngIf="details.hidden==false" (click)="hideStageContent(details)"
            appTrackClick
            [buttonProps]="{
              title:'hitmaker_post_production_hide',
              feature_context:'HITMAKER'
            }"
            >HIDE</button>
            <div id="btnDiv" fxFlex="row">
              <button style="color: red;" (click)="deleteStageMovie(details.id)"
              appTrackClick
              [buttonProps]="{
                title:'hitmaker_post_production_delete',
                feature_context:'HITMAKER'
              }"
              >DELETE</button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>